import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';

interface NCFileDetailsJobsTimelineProps {}

const NCFileDetailsJobsTimelineComponent: FC<NCFileDetailsJobsTimelineProps> = ({
  getNCFileById,
  getProductionBatchByNCFile,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
}) => {
  const title = useTitle();

  useNCFileDetails({
    getNCFileById,
    getProductionBatchByNCFile,
    getTools,
    clearTools,
    updateHeaderConfig,
    operationsSearch,
    loadAllJobs: false,
    getNCFileByName,
  });

  return (
    <DetailsPageWrapper title={title.job}>
      <MultiMachineTimeline />
    </DetailsPageWrapper>
  );
};

const NCFileDetailsJobsTimeline = connect(null, {
  getNCFileById,
  getProductionBatchByNCFile,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsJobsTimelineComponent);

export { NCFileDetailsJobsTimeline };
